export const getSortableId = (s: string): number => {
  const specials = [",", "-"];
  for (const special of specials) {
    if (s.indexOf(special) >= 0) {
      return Number(s.split(special)[0]);
    }
  }
  return Number(s);
};
